import { useEffect } from 'react';

const RouteWrapper = ({ title, children }) => {
    useEffect(() => {
        const config = window.APP_CONFIG;
        if (title) {
            document.title = title + ' | ' + config.title;
        }
    }, [title]);

    return children;
};

export default RouteWrapper;
